import { createSvgComponent } from "../../icon/createSvgComponent";
import BtStop from "@core/__generated__/icon/figma/bt-stop.svg";
export default createSvgComponent(BtStop);